import {getUserProjection, transformExtent} from 'ol/proj';
import {DataTile as DataTileSource} from 'ol/source';
import LRUCache from 'ol/structs/LRUCache';
import {
  createOrUpdate as createTileCoord,
  getKey as getTileCoordKey,
} from 'ol/tilecoord';

import {createNumpyLoader} from '@explorer/util/map';

export const createNumpySource = (view, mapStats, numpyUrl) => {
  const tileCache = new LRUCache(128);
  const numpySource = new DataTileSource({
    loader: createNumpyLoader(numpyUrl),
    bandCount: 5,
  });

  const checkForCompletion = () => {
    let nLoading = 0;
    // eslint-disable-next-line
    for (const key in numpySource.tileLoadingKeys_) {
      nLoading++;
    }
    if (nLoading === 0) {
      // hard dependency on web mercator for this one.
      const tileGrid = numpySource.getTileGrid();
      const z = tileGrid.getZForResolution(
        view.current.getResolution(),
        numpySource.zDirection
      );
      const extent = transformExtent(
        view.current.calculateExtent(),
        getUserProjection(),
        'EPSG:3857'
      );

      const tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z);

      // reset the map stats.
      mapStats.reset();

      // collect statistics for each tile in the range.
      for (let x = tileRange.minX; x <= tileRange.maxX; x++) {
        for (let y = tileRange.minY; y <= tileRange.maxY; y++) {
          const tileCoord = createTileCoord(z, x, y);
          const tileCoordKey = getTileCoordKey(tileCoord);
          if (tileCache.containsKey(tileCoordKey)) {
            // add this to the statistics
            const tile = tileCache.get(tileCoordKey);
            mapStats.add(tile);
          }
        }
      }
      // let the parent know everything is finished
      numpySource.dispatchEvent('alltilesloaded');
    }
  };

  numpySource.on('tileloadend', evt => {
    if (evt.tile) {
      // add it to the tile cache
      const tileCoord = createTileCoord(
        evt.tile.tileCoord[0],
        evt.tile.tileCoord[1],
        evt.tile.tileCoord[2]
      );
      const tileCoordKey = getTileCoordKey(tileCoord);
      tileCache.set(tileCoordKey, evt.tile);
    }
    checkForCompletion();
  });

  numpySource.on('tileloaderror', () => {
    checkForCompletion();
  });

  return numpySource;
};
